import { useNavigate } from '@tanstack/react-router';
import { useListRubrics } from '@sara/api-client';
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@sara/ui/components/dialog';
import type { DialogBaseProps } from '@sara/ui/components/dialog-provider';
import { CreateRubricOptions } from '../../components/CreateRubricOptions';
import { useOrgSlug } from '../../../auth';

interface NewRubricDialogProps extends DialogBaseProps {
  orgId: string;
}

function NewRubricDialog({ orgId, onClose }: NewRubricDialogProps) {
  const navigate = useNavigate();
  const orgSlug = useOrgSlug();
  const { data: rubrics, isError } = useListRubrics({ orgId });

  function handleStartBlank() {
    void navigate({ to: '/orgs/$orgSlug/rubrics/new', params: { orgSlug } });
    onClose();
  }

  function handleFork(rubricId: string) {
    void navigate({
      to: '/orgs/$orgSlug/rubrics/new',
      params: { orgSlug },
      search: { forkFrom: rubricId },
    });
    onClose();
  }

  return (
    <DialogContent className="sm:max-w-xl">
      <DialogHeader>
        <DialogTitle className="font-display text-2xl font-medium tracking-tight">
          Create a rubric
        </DialogTitle>
        <DialogDescription>
          Pick a starting point — everything stays editable until you create the rubric.
        </DialogDescription>
      </DialogHeader>
      <CreateRubricOptions
        rubrics={rubrics}
        isError={isError}
        onFork={handleFork}
        onStartBlank={handleStartBlank}
      />
    </DialogContent>
  );
}

export { NewRubricDialog };
